import { createFileRoute } from '@tanstack/react-router';

import { FriendGamePageWidget } from '@features/game/pages/FriendGamePage/FriendGamePageWidget';
import { FriendGameProvider } from '@features/game/providers/FriendGameProvider';

export const Route = createFileRoute('/game/friend_/$gameId')({
  component: Page,
});

function Page() {
  const { gameId } = Route.useParams();

  return (
    <FriendGameProvider inviteId={gameId}>
      <FriendGamePageWidget key={gameId} gameId={gameId} />
    </FriendGameProvider>
  );
}
